import { render, staticRenderFns } from "./SupplierNew.vue?vue&type=template&id=d2ae44da&scoped=true&"
import script from "./SupplierNew.vue?vue&type=script&lang=js&"
export * from "./SupplierNew.vue?vue&type=script&lang=js&"
import style0 from "./SupplierNew.vue?vue&type=style&index=0&id=d2ae44da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ae44da",
  null
  
)

export default component.exports